import { defineMessages } from 'react-intl';

export const scope = 'app.containers.ActionIcon';

export default defineMessages({
  defaultCrossLinkText: {
    id: `${scope}.defaultCrossLinkText`,
    defaultMessage: 'Go back',
  },
  defaultCrossButtonText: {
    id: `${scope}.defaultCrossButtonText`,
    defaultMessage: 'Close',
  },
});
